import React from 'react';
import { createRoot } from 'react-dom/client';
import { Index } from './containers/Index';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import "./style/index.css";
import "@fontsource/montserrat";
import "@fontsource/montserrat/400.css"
import "@fontsource/montserrat/500.css"
import "@fontsource/montserrat/600.css"
import "@fontsource/montserrat/700.css"

const root = createRoot(document.getElementById('root'));

root.render(
  <Index />
);
window.addEventListener("load", () => {
  if ("serviceWorker" in navigator) {
    serviceWorkerRegistration.register("/service-worker.js");
  }
});


window.addEventListener("offline", function () {
  navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    // Let's see if you have a subscription already
    return serviceWorkerRegistration.pushManager.getSubscription();
  })
    .then(function (subscription) {
      if (!subscription) {
        // You do not have subscription
      }
      // You have subscription.
      // Send data to service worker
      navigator.serviceWorker.controller.postMessage({ type: `IS_OFFLINE` });

    })

});